import React from "react";
import ReactDOM from "react-dom";
import App from "./app";

const rootElement = document.getElementById("savings-calculator-root");

// Precios ya resueltos por el backend (`json_script` en la plantilla). No hay
// endpoint de precios: el único origen es `services.fuel_price`.
const readFuelPrices = () => {
    const el = document.getElementById("savings-calculator-prices");
    if (!el) return {};
    try {
        return JSON.parse(el.textContent) || {};
    } catch (error) {
        console.error("[savings-calculator] precios ilegibles", error);
        return {};
    }
};

if (rootElement) {
    const legalEl = document.getElementById("savings-calculator-legal");
    const fuelPrices = readFuelPrices();

    const config = {
        eyebrow: rootElement.dataset.eyebrow || "",
        title: rootElement.dataset.title || "",
        subtitle: rootElement.dataset.subtitle || "",
        legalHtml: legalEl ? legalEl.innerHTML : "",
        mode: rootElement.dataset.mode || "multi",
        // Datos de la versión precargada (solo modo `single`): el endpoint
        // /versions/ no expone la imagen, la entrega el bloque junto al motor.
        preselectedVersionId: rootElement.dataset.preselectedVersion || "",
        preselectedName: rootElement.dataset.preselectedName || "",
        preselectedMotor: rootElement.dataset.preselectedMotor || "",
        preselectedImage: rootElement.dataset.preselectedImage || "",
        versionsUrl: rootElement.dataset.versionsUrl,
        calculateUrl: rootElement.dataset.calculateUrl,
        fuelPrices,
        defaultAnnualKm: fuelPrices.default_annual_km,
    };

    ReactDOM.render(<App config={config} />, rootElement);
}
